// User Google token DAO — read + delete for the `user_google_tokens` table.
// Used by the Gmail OAuth settings page.

import { BaseDao, type SupabaseClient } from '../base.ts';

interface UserGoogleTokenRow {
  user_id: string;
  scope: string | null;
}

export class UserGoogleTokenDao extends BaseDao<UserGoogleTokenRow> {
  protected readonly dependentResources = ['user_google_tokens'];

  constructor(sb: SupabaseClient) {
    super(sb, 'user_google_tokens');
  }

  /** Get the stored OAuth scope for one user, or null if no row. */
  async getScopeForUser(userId: string): Promise<string | null> {
    const { data } = await this.sb
      .from('user_google_tokens')
      .select('scope')
      .eq('user_id', userId)
      .maybeSingle();
    return (data as { scope: string | null } | null)?.scope ?? null;
  }

  async deleteForUser(userId: string): Promise<void> {
    const { error } = await this.sb
      .from('user_google_tokens')
      .delete()
      .eq('user_id', userId);
    if (error) throw error;
  }
}
